var _rect, _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1850 -710C-1850 -711.105 -1849.1 -712 -1848 -712H311C312.105 -712 313 -711.105 313 -710V971C313 972.105 312.105 973 311 973H-1848C-1849.1 973 -1850 972.105 -1850 971V-710Z",
    fill: "#E7EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1805 -64C-1805 -65.1046 -1804.1 -66 -1803 -66H246C247.105 -66 248 -65.1046 248 -64V850C248 851.105 247.105 852 246 852H-1803C-1804.1 852 -1805 851.105 -1805 850V-64Z",
    fill: "#D0D5DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8922_204886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -289,
    y: -21,
    width: 320,
    height: 308.227,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8922_204886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00012 4.00003L9.00012 7.00003L6.00012 10",
    stroke: "#64748B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 13.5C10.59 13.5 13.5001 10.5899 13.5001 7.00002C13.5001 3.41016 10.59 0.500015 7.00012 0.500015C3.41027 0.500015 0.500122 3.41016 0.500122 7.00002C0.500122 10.5899 3.41027 13.5 7.00012 13.5Z",
    stroke: "#64748B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -288.5,
    y: -20.5,
    width: 319,
    height: 307.227,
    rx: 7.5,
    stroke: "#E7EAEE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1848 -711H311V-713H-1848V-711ZM312 -710V971H314V-710H312ZM311 972H-1848V974H311V972ZM-1849 971V-710H-1851V971H-1849ZM-1848 972C-1848.55 972 -1849 971.552 -1849 971H-1851C-1851 972.657 -1849.66 974 -1848 974V972ZM312 971C312 971.552 311.552 972 311 972V974C312.657 974 314 972.657 314 971H312ZM311 -711C311.552 -711 312 -710.552 312 -710H314C314 -711.657 312.657 -713 311 -713V-711ZM-1848 -713C-1849.66 -713 -1851 -711.657 -1851 -710H-1849C-1849 -710.552 -1848.55 -711 -1848 -711V-713Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8922_204886",
    x: -337,
    y: -49,
    width: 416,
    height: 404.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.454902 0 0 0 0 0.545098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.454902 0 0 0 0 0.545098 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8922_204886",
    result: "effect2_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8922_204886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8922_204886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCalenderIcon);
export default __webpack_public_path__ + "static/media/RightCalenderIcon.a71c5a779ab1b7630a732e0124271a36.svg";
export { ForwardRef as ReactComponent };